import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";
import { LOGIN_URL } from "../services/api";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [loggedInUser, setLoggedInUser] = useState(null);
  const [tenant, setTenant] = useState(null); // 👈 store tenant info too
  const [isLoading, setIsLoading] = useState(true);

  // Load user + tenant from localStorage on mount
  useEffect(() => {
    const token = localStorage.getItem("token");
    const userStr = localStorage.getItem("user");
    const tenantStr = localStorage.getItem("tenant") || localStorage.getItem("company");

    const user =
      userStr && userStr !== "undefined" ? JSON.parse(userStr) : null;
    const tenant =
      tenantStr && tenantStr !== "undefined" ? JSON.parse(tenantStr) : null;

    if (token && user) {
      setLoggedInUser(user);
      setTenant(tenant);
      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    }
    setIsLoading(false);
  }, []);

  // Login function
  const login = async (companyName, email, password) => {
    try {
      const response = await axios.post(`${LOGIN_URL}`, {
        tenantSlug: companyName,
        email,
        password,
      });

      // The auth API returns the organization as `company` (older tenants used
      // `tenant`). Normalize both shapes so all module requests share the same
      // persisted token and tenant context.
      const { token, user, tenant: responseTenant, company } = response.data.data;
      const tenant = responseTenant || company;

      // Store in localStorage
      localStorage.setItem("token", token);
      localStorage.setItem("user", JSON.stringify(user));
      localStorage.setItem("tenant", JSON.stringify(tenant));
      localStorage.setItem("company", JSON.stringify({
        ...(company || tenant || {}),
        role: user?.role,
      }));

      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

      setLoggedInUser(user);
      setTenant(tenant);

      return { success: true, user, tenant };
    } catch (err) {
      return {
        success: false,
        message: err.response?.data?.message || "Login failed",
      };
    }
  };

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("tenant");
    delete axios.defaults.headers.common["Authorization"];
    setLoggedInUser(null);
    setTenant(null);
  };

  return (
    <UserContext.Provider
      value={{ loggedInUser, tenant, login, logout, isLoading }}
    >
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
